
























































































































import { ProductType } from "@/models/products/product";
import { Component, Prop, Mixins } from "vue-property-decorator";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { LineItem, Order } from "@/models/order/order";
import { EventBus } from "@/event-bus";
import { Mobile } from "@/mixins/mobile";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import ContactUs from "@/components/elements/modal/ContactUs.vue";

@Component({
  components: {
    ConfirmNewQuote,
    ContactUs
  }
})
export default class Menu extends Mixins(Mobile) {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];
  protected type = ProductType;
  protected showContactUsModal = false;
  protected showNewQuoteModal = false;
  protected isOpen = false;

  created(): void {
    EventBus.$on("createNewQuote", () => {
      this.toggleNewQuoteModal();
    });
    EventBus.$on("toggleSidebar", () => {
      this.isOpen = !this.isOpen;
    });
  }

  beforeDestroy(): void {
    EventBus.$off("createNewQuote");
    EventBus.$off("toggleSidebar");
  }

  protected hide(): void {
    this.isOpen = false;
    EventBus.$emit("sidebarClosed");
  }

  protected toggleNewQuoteModal(): void {
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showNewQuoteModal = true;
    } else {
      this.clearOrder();
    }
  }

  protected closeNewQuoteModal(): void {
    this.showNewQuoteModal = false;
  }

  protected toggleContactUsModal() {
    this.showContactUsModal = true;
  }

  protected closeContactUsModal(): void {
    this.showContactUsModal = false;
  }

  protected async clearOrder(): Promise<void> {
    this.closeNewQuoteModal();
    this.hide();
    await this.resetOrder();
    // resetOrder (ClearOrder) empties the cart but keeps the selected
    // customer, so keep that customer's price-level multiplier. Only fall
    // back to base price (id 1) when no customer with a price level remains.
    const priceLevelId = this.storeOrder?.customer_netsuite_price_level_id;
    const customerLevel = priceLevelId
      ? this.storePriceLevels.find(l => l.id === priceLevelId) ?? null
      : null;
    const baseLevel = this.storePriceLevels.find(l => l.id === 1) ?? null;
    await this.addMultiplier(customerLevel ?? baseLevel);

    if (this.$route.path !== "/collections/umbrella") {
      this.$router.push("/collections/umbrella");
    }
  }
}
